import { StandardEvents } from '@shopify/events';

const messages = {
  empty: ['💗 Come back!', '✨ Something caught your eye?', '💎 Still looking?'],
  filled: ['💗 Your jewellery is waiting...', '✨ Still thinking about it?', '💎 Your sparkle is waiting...'],
};

let originalTitle = document.title;
let cartItemCount = Number(document.documentElement.dataset.tvaraCartItemCount) || 0;
let messageIndex = 0;
let rotationId;

function activeMessages() {
  return cartItemCount > 0 ? messages.filled : messages.empty;
}

function showNextMessage() {
  const active = activeMessages();
  document.title = active[messageIndex % active.length];
  messageIndex += 1;
}

function stopRotation() {
  clearInterval(rotationId);
  rotationId = undefined;
}

function startRotation() {
  stopRotation();
  messageIndex = 0;
  showNextMessage();
  rotationId = setInterval(showNextMessage, 2500);
}

function restoreTitle() {
  stopRotation();
  document.title = originalTitle;
}

document.addEventListener('visibilitychange', () => {
  if (document.hidden) startRotation();
  else restoreTitle();
});

window.addEventListener('pagehide', restoreTitle);

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise
    ?.then(({ cart, detail }) => {
      cartItemCount = cart?.totalQuantity ?? detail?.itemCount ?? cartItemCount;
      if (document.hidden) startRotation();
    })
    .catch(() => {});
});
